import { xlCol, xlColq } from '../../../common/constants'

export const TRANSACTION_LABEL_MAP = {
  BKNG: 'Booking',
  DEL: 'Delivery',
  RFND: 'Refund',
}

export const TRANSACTION_LABEL = {
  Booking: 'Booking (A)',
  Delivery: 'Delivery (B)',
  Refund: 'Refund (C)',
}

export const TRANSACTION_CONFIG = {
  [TRANSACTION_LABEL_MAP.BKNG]: {
    freightLabel: 'Freight',
    expenseLabel: 'Booking Expense',
  },
  [TRANSACTION_LABEL_MAP.DEL]: {
    freightLabel: 'Total LR Amt',
    expenseLabel: 'Delivery Expense',
  },
  [TRANSACTION_LABEL_MAP.RFND]: {
    freightLabel: 'Freight',
    expenseLabel: 'Refund Expense',
  },
}

export const HeaderColumn = [
  { headerName: 'Branch', exportHead: 'Branch', field: 'Branch', xlCol },
  { headerName: 'User', exportHead: 'User', field: 'User', xlCol },
  { headerName: 'Transaction Type', exportHead: 'Transaction Type', field: 'TransactionType', xlCol },
  { headerName: 'Payment Type', exportHead: 'Payment Type', field: 'PaymentType', xlCol },
  { headerName: 'Payment Mode', exportHead: 'Payment Mode', field: 'PaymentMode', xlCol },
]

export const summaryColumnDefs = [
  { field: 'Transaction', headerName: 'Transactions', exportHead: 'Transactions', align: 'left', xlCol: { dataType: 'string', dataFormatter: null }, isSelected: true, isMandatory: true, isDefault: true, hideHeader: true, isSortIcon: true, },
  { field: 'PaidAmt', headerName: 'Paid', exportHead: 'Paid', align: 'right', xlCol: { dataType: 'quantity', dataFormatter: null }, isSelected: true, isMandatory: false, isDefault: true, isSortIcon: true, },
  { field: 'PaidManAmt', headerName: 'Paid Manual', exportHead: 'Paid Manual', align: 'right', xlCol: { dataType: 'quantity', dataFormatter: null }, isSelected: true, isMandatory: false, isDefault: true, isSortIcon: true, },
  { field: 'TopayAmt', headerName: 'ToPay', exportHead: 'ToPay', align: 'right', xlCol: { dataType: 'quantity', dataFormatter: null }, isSelected: true, isMandatory: false, isDefault: true, isSortIcon: true, },
  { field: 'TopayManAmt', headerName: 'ToPay Manual', exportHead: 'ToPay Manual', align: 'right', xlCol: { dataType: 'quantity', dataFormatter: null }, isSelected: true, isMandatory: false, isDefault: true, isSortIcon: true, },
  { field: 'DDDVAmt', headerName: 'ToPay DDDV', exportHead: 'ToPay DDDV', align: 'right', xlCol: { dataType: 'quantity', dataFormatter: null }, isSelected: true, isMandatory: false, isDefault: true, isSortIcon: true, },
  { field: 'OnAccAmt', headerName: 'On Account', exportHead: 'On Account', align: 'right', xlCol: { dataType: 'quantity', dataFormatter: null }, isSelected: true, isMandatory: false, isDefault: true, isSortIcon: true, },
  { field: 'CODAmt', headerName: 'COD', exportHead: 'COD', align: 'right', xlCol: { dataType: 'quantity', dataFormatter: null }, isSelected: true, isMandatory: false, isDefault: true, isSortIcon: true, },
  { field: 'SelfAmt', headerName: 'Self Booking', exportHead: 'Self Booking', align: 'right', xlCol: { dataType: 'quantity', dataFormatter: null }, isSelected: true, isMandatory: false, isDefault: true, isSortIcon: true, },
  { field: 'FOCAmt', headerName: 'FOC', exportHead: 'FOC', align: 'right', xlCol: { dataType: 'quantity', dataFormatter: null }, isSelected: true, isMandatory: false, isDefault: true, isSortIcon: true, },
  { field: 'TotalAmt', headerName: 'Total Amount', exportHead: 'Total Amount', align: 'right', xlCol: { dataType: 'quantity', dataFormatter: null }, isSelected: true, isMandatory: true, isDefault: true, isSortIcon: true, },
]

export const getcolumnDefs = (UseFormattedLRinReports, isTableOne = true) => [
  { headerName: 'S/N', exportHead: 'S/N', field: 'SN', xlCol, hideHeader: true },
  { headerName: 'LR Number', exportHead: 'LR No', field: 'LRNO', xlCol, isSortIcon: true, },
  UseFormattedLRinReports === 3 && { headerName: 'Formatted LR Number', exportHead: 'Formatted LRNO', field: 'FormattedLRNO', xlCol, isSortIcon: true, },
  { headerName: 'Booking Date', exportHead: 'Booking Date', field: 'TransactionDate', xlCol, isSortIcon: true, },
  { headerName: 'Source', exportHead: 'Source', field: 'FromCity', xlCol, isSortIcon: true, },
  { headerName: 'Destination', exportHead: 'Destination', field: 'ToCity', xlCol, isSortIcon: true, },
  { headerName: 'Payment Type', exportHead: 'Pymt.Type', field: 'TYPE', xlCol, isSortIcon: true, },
  { headerName: 'Consignment Type', exportHead: 'Consign. Type', field: 'ConsignmentType', xlCol, isSortIcon: true, },
  { headerName: 'User Name', exportHead: 'User Name', field: 'UserName', xlCol, isSortIcon: true, },
  { headerName: 'Units', exportHead: 'Units', field: 'Quantity', xlCol: xlColq, isSortIcon: true, },
  { headerName: 'Freight', exportHead: 'Freight', field: 'LRAmount', xlCol: xlColq, isSortIcon: true, },
  { headerName: 'Other Charges', exportHead: 'Other Charges', field: 'OtherCharges', xlCol: xlColq, isSortIcon: true, },
  { headerName: 'Total Amount', exportHead: 'Total Amount', field: 'Amount', xlCol: xlColq, isSortIcon: true, },
  isTableOne && { headerName: 'Delivery Expense', exportHead: 'Delivery Expense', field: 'DeliveryExpense', xlCol: xlColq, isSortIcon: true, },
  isTableOne && { headerName: 'Net Amount', exportHead: 'Net Amount', field: 'TotalAmount', xlCol: xlColq, isSortIcon: true, },
].filter(Boolean)

export const getSubheading = (total = 14) => [
  { headerName: 'SN', colspan: total - 10 },
  { headerName: 'FromCity', colspan: 3 },
  { headerName: 'ConsignmentType', colspan: 3 },
  { headerName: 'LRAmount', colspan: 4, textAlign: 'right' },
]

export const getTotalRow = (UseFormattedLRinReports) => {
  const total = UseFormattedLRinReports === 3 ? 15 : 14
  const snColspan = total - 6
  return [
    { headerName: 'SN', colspan: snColspan },
    { headerName: 'Quantity', colspan: 1 },
    { headerName: 'LRAmount', colspan: 1 },
    { headerName: 'OtherCharges', colspan: 1 },
    { headerName: 'Amount', colspan: 1 },
    { headerName: 'DeliveryExpense', colspan: 1 },
    { headerName: 'TotalAmount', colspan: 1 },
  ]
}

export const tableHeadObject = (val, TranType) => ({
  SN: 'S/N',
  LRNO: 'LR NO.',
  TransactionDate: `${val} Date`,
  FromCity: 'Source',
  ToCity: 'Destination',
  isHeading: true,
  TYPE: 'Payment Type',
  ConsignmentType: 'Consignment Type',
  UserName: 'User Name',
  Quantity: 'Units',
  LRAmount: 'Freight',
  OtherCharges: 'Other Charges',
  Amount: 'Total Amount',
  DeliveryExpense: val === 'Booking' ? 'Booking Expense' : 'Delivery Expense',
  TotalAmount: 'Net Amount',
})

const baseStyle = {
  minCellHeight: 36,
  fontSize: 16,
  cellPadding: 6,
  valign: 'middle',
  fontStyle: 'normal',
  font: 'Roboto',
  textColor: [0, 0, 0],
  cellWidth: 'auto',
}

export const getColumnStyle = (addcol = false) => {
  let colWidths = [60, 60, 60, 79, 100, 100, 100, 120, 90, 120, 70, 70, 70, 70, 130]
  if (addcol) {
    const extraColWidth = 80
    const shrinkPerCol = Math.floor(extraColWidth / colWidths.length)
    colWidths = colWidths.map(w => w - shrinkPerCol)
    colWidths.splice(2, 0, extraColWidth)
  }
  return colWidths.map((width, index) => ({
    ...baseStyle,
    cellWidth: width,
    halign: index > (addcol ? 7 : 6) ? 'right' : 'left',
  }))
}